.variant\: {
  &unstyled {
    color: inherit;
    font: inherit;
    text-decoration: inherit;
  }
  &container {
    @extend .variant\:unstyled;

    display: block;
  }
}
